// Import your centralized Axios instance
import api from './api';

export const mappingService = {
  // Fetch mapping profiles, optionally filtered by import_type
  // (e.g. 'GL_ACCOUNT', 'STOCK_CODE', 'COST_CENTER', 'SITE')
  getMappings: async (importType) => {
    const response = await api.get('/mappings', {
      params: importType ? { import_type: importType } : {},
    });
    return response.data;
  },

  // Save a new mapping profile. `payload` already includes its import_type.
  saveMapping: async (payload) => {
    const response = await api.post('/mappings', payload);
    return response.data;
  },
};

export default mappingService;